import { render, staticRenderFns } from "./NavigationEditor.vue?vue&type=template&id=649391b1&scoped=true&"
import script from "./NavigationEditor.vue?vue&type=script&lang=ts&"
export * from "./NavigationEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationEditor.vue?vue&type=style&index=0&id=649391b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649391b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDivider,VExpansionPanelContent,VSelect,VTextField})
